import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { InboxPageRoutingModule } from './inbox-routing.module';

import { InboxPage } from './inbox.page';
import {PipesModule} from "@pipes/pipes.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        InboxPageRoutingModule,
        PipesModule
    ],
    exports: [
        InboxPage
    ],
    declarations: [InboxPage]
})
export class InboxPageModule {}
